module.exports = __webpack_public_path__ + "images/emoji/poodle.afbdc734a674914aee2e.png";